import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils/utils';
import i18n from '@/lib/i18n';

function getSlides() {
    return [
    {
        image: 'assets/images/home/home-1.png',
        text: i18n.t('welcome:documentezLAvancementDesChantiersLesEtatsDes'),
    },
    {
        image: 'assets/images/home/home-2.png',
        text: i18n.t('welcome:photographiezVosColisALaReceptionOuL'),
    },
    {
        image: 'assets/images/home/home-3.png',
        text: i18n.t('welcome:constituezUnDossierSolidePourVosDeclarationsD'),
    },
    ];
}

export function HomeCarousel({ className }) {
    // Pas de `t` utilisé directement : l'appel abonne le composant aux changements
    // de langue, pour que getSlides() soit réévalué.
    useTranslation();
    const slides = getSlides();
    const [currentSlide, setCurrentSlide] = useState(0);

    // Auto-advance carousel every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className={cn('relative w-full h-full bg-foreground-dark rounded-2xl overflow-hidden', className)}>
            {/* Slides */}
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`absolute inset-0 transition-opacity duration-1000 ${
                        index === currentSlide ? 'opacity-100' : 'opacity-0'
                    }`}
                >
                    {/* Background Image with Overlay */}
                    <div className="absolute inset-0">
                        <img src={slide.image} alt="" className="w-full h-full object-cover" />
                        {/* Dark gradient overlay */}
                        <div className="absolute inset-0 bg-gradient-to-b from-foreground-dark/60 via-foreground-dark/50 to-foreground-dark/70" />
                    </div>

                    {/* Content */}
                    <div className="relative z-10 h-full flex flex-col justify-end px-10 py-[60px] bg-gradient-to-b from-transparent via-foreground-dark/10 to-foreground-dark/30">
                        <div className="max-w-[450px]">
                            <p className="text-[15px] leading-relaxed text-background font-medium">{slide.text}</p>
                        </div>
                    </div>
                </div>
            ))}

            {/* Pagination Dots */}
            <div className="absolute bottom-[30px] left-10 z-20 flex gap-3">
                {slides.map((_, index) => (
                    <Button
                        key={index}
                        variant="plain"
                        color="neutral"
                        size="auto"
                        onClick={() => setCurrentSlide(index)}
                        className={`h-2 rounded-full transition-all duration-300 p-0 hover:bg-transparent ${
                            index === currentSlide
                                ? 'w-8 bg-secondary hover:bg-secondary'
                                : 'w-2 bg-background hover:bg-background/80'
                        }`}
                        aria-label={`Aller au slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
}
